__turbopack_context__.v({
  "active": "Jk4Sra_active",
  "announcementBtn": "Jk4Sra_announcementBtn",
  "announcementCta": "Jk4Sra_announcementCta",
  "announcementItem": "Jk4Sra_announcementItem",
  "announcementItemOpen": "Jk4Sra_announcementItemOpen",
  "announcementWrapperOpen": "Jk4Sra_announcementWrapperOpen",
  "announcementsContainer": "Jk4Sra_announcementsContainer",
  "announcementsTabList": "Jk4Sra_announcementsTabList",
  "announcementsWrapper": "Jk4Sra_announcementsWrapper",
  "backBtn": "Jk4Sra_backBtn",
  "badge": "Jk4Sra_badge",
  "bigImg": "Jk4Sra_bigImg",
  "clearAllBtn": "Jk4Sra_clearAllBtn",
  "dismissButton": "Jk4Sra_dismissButton",
  "emptyState": "Jk4Sra_emptyState",
  "horizontalLine": "Jk4Sra_horizontalLine",
  "smallImg": "Jk4Sra_smallImg",
});
